// The Harvard contrast: 24% of applicants reach a top-two rating for
// activities, 42% for academics. The landing page's evidence block carried
// it (pick A, 2026-09-29); since pick E the same evening it is one tile of the
// trends band (data/landingTrends.js imports it from here, the one pinned
// copy).
//
// Copied from the research record,
// marketing/posts/2026-09-23-truly-unusual-achievement.sources.md (tags H2,
// H3), and re-read against the court filing on 2026-09-29.
// landingEvidence.test.js pins them to that file. The record's warning: the
// figures describe Harvard's own applicant pool, not "colleges", so the page
// says "of Harvard applicants", every time.

const HARVARD_DOC = 'Findings of fact, SFFA v. Harvard (D. Mass. 2019)';
const HARVARD_URL = 'https://www.harvard.edu/admissionscase/wp-content/uploads/sites/6/2021/06/2019-10-30_dkt_672_findings_of_fact_and_conclusions_of_law.pdf';

// The contrast.
export const HARVARD_LEAD = {
    activities: { value: '24%', tag: 'H2' },
    academics: { value: '42%', tag: 'H3' },
    source: `${HARVARD_DOC}, p. 55`,
    url: HARVARD_URL,
};
